import { render, staticRenderFns } from "./list-tps.vue?vue&type=template&id=1b765f42&"
import script from "./list-tps.vue?vue&type=script&lang=js&"
export * from "./list-tps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "list-tps.vue"
export default component.exports